import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'recaudacion/consulta-masiva-de-saldos/';

export const MAX_CUENTAS = 1000;

/**
 * POST encola la consulta masiva de saldos del predial; el Excel llega por correo
 * @param {object} values
 * @param {number} values.anio - Año fiscal límite
 * @param {number} values.bimestre - Bimestre límite (1-6)
 * @param {Array<string>} [values.cuentas] - Claves catastrales municipales
 * @param {File} [values.archivo] - Excel .xlsx con las cuentas en la columna A desde la fila 2
 * @returns {Promise<object|false>}
 */
export const encolarSaldosMasivos = async ({
  anio, bimestre, cuentas, archivo,
}) => {
  try {
    if (archivo) {
      const formData = new FormData();
      formData.append('archivo', archivo);
      formData.append('anio', anio);
      formData.append('bimestre', bimestre);
      const response = await API.post(baseURI, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data ?? true;
    }
    const response = await API.post(baseURI, { cuentas, anio, bimestre });
    return response.data ?? true;
  } catch (err) {
    onError(err);
    return false;
  }
};
